<template>
    <v-container fluid>
        <v-row v-if="input.length !== 0">
            <v-col
                cols="12"
                md="5"
                lg="4"
                sm="6"
                v-for="(entity, i) in input"
                :key="i"
                class="px-0 py-0"
            >
                <v-container class="pa-0">
                    <v-hover v-slot:default="{ isHovering }">
                        <v-card
                            class="mr-5 mb-5 card"
                            :style="setCardStyle(entity, isHovering)"
                            outlined
                            :disabled="disabled"
                            @click="selectCard(entity)"
                        >
                            <v-card-actions class="d-block my-3">
                                <v-avatar color="#F5F5F5">
                                    <v-icon
                                        v-if="entity.iconName"
                                        :style="activeStatus(entity) ? 'color:#79bf12' : ''"
                                    >
                                        {{ entity.iconName }}
                                    </v-icon>
                                    <v-img
                                        v-else
                                        :src="controlImg(entity.imageUrl)"
                                        max-height="45"
                                        max-width="45"
                                    />
                                </v-avatar>
                                <v-card-text class="mt-1 py-2 px-5 font-weight-regular">
                                    {{ entity.value.localizedAttributes.cz.description }}
                                </v-card-text>
                            </v-card-actions>
                        </v-card>
                    </v-hover>
                </v-container>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col>
                <span class="font-weight-regular mb-6">Objekt neexistuje</span>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import { ref, computed } from 'vue';
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    selectedItems: {
        type: Array,
        default: () => []
    },
    input: Array,
    data: String,
    disabled: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['clicked']);

const selected = ref([...props.selectedItems]);

const prepareOutput = computed(() => (selected.value ?? []).map(r => r.value.id));

const controlImg = (icon) => icon || '/icons/mendelu_icon.png';

const selectCard = (entity) => {
    if (activeStatus(entity)) {
        selected.value = selected.value.filter(x => x.value.id !== entity.value.id);
    } else {
        selected.value.push(entity);
    }

    emit('clicked', {
        type: props.data,
        value: prepareOutput.value
    });
};

const activeStatus = (entity) => selected.value.some((x) => entity.value.id === x.value.id);

const setCardStyle = (entity, hover) => {
    const activeStyle = 'box-shadow: inset 0px 0px 0px 4px #79bf12;';
    const hoverStyle = 'box-shadow: inset 0px 0px 0px 2px #79bf12;';
    const defaultStyle = 'box-shadow: inset 0px 0px 0px 1px #eeeeef';

    return activeStatus(entity) ? activeStyle : hover ? hoverStyle : defaultStyle;
};

</script>

<style scoped>
.card {
    text-align: center;
    border-radius: 50px;
    cursor: pointer;
}
</style>
